module.exports = __webpack_public_path__ + "img/deco-12.c4cda47e.png";